import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error: any) => {
        // Не повторяем запрос при ошибках 404
        if (error?.status === 404) {
          return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: (_failureCount, error: any) => {
        // Не повторяем запрос при ошибках 404
        if (error?.status === 404) {
          return false;
        }
        return false; // Мутации не повторяем по умолчанию
      },
    },
  },
});

// Упрощенная инициализация без лишних проверок
const DEV = import.meta.env.DEV;
DEV && console.log('[main.tsx] Module loaded, starting render...');
const rootElement = document.getElementById('root');
DEV && console.log('[main.tsx] Root element:', rootElement);

if (rootElement) {
  try {
    DEV && console.log('[main.tsx] Creating React root...');
    const root = ReactDOM.createRoot(rootElement);
    DEV && console.log('[main.tsx] Rendering app...');
    root.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </React.StrictMode>
    );
    DEV && console.log('[main.tsx] App rendered successfully');
    (window as any).__APP_LOADED__ = true;
  } catch (error) {
    console.error('[main.tsx] Error:', error);
    rootElement.innerHTML = '<div style="padding: 20px; text-align: center; color: red;"><h2>Ошибка при рендеринге</h2><p>' + String(error) + '</p><button onclick="location.reload()" style="padding: 10px 20px; margin-top: 10px;">Перезагрузить</button></div>';
  }
} else {
  console.error('[main.tsx] Root element not found!');
  document.body.innerHTML = '<div style="padding: 20px; text-align: center; color: red;"><h2>Ошибка: элемент root не найден</h2></div>';
}



























